<template>
  <div class="mall-agree-check" @click="$emit('change', !checked)">
    <MallCheckBox :checked="checked" />
    <span class="mall-agree-check__label">{{ label }}</span>
  </div>
</template>

<script>
import MallCheckBox from '@/components/new/atoms/MallCheckBox.vue'

export default {
  name: 'MallAgreeCheck',
  components: {
    MallCheckBox,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.mall-agree-check {
  display: flex;
  padding: 0 4px;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.mall-agree-check__label {
  flex: 1;
  min-width: 0;
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-normal);
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallAgreeCheck.vue